/*
 * The "Check your email" words after a school password reset is asked for
 * (TDI-702, F-01 FR7). One place, so the school sign-in page and the
 * Change password dialog in the portal say exactly the same thing.
 */
export const RESET_SENT_TITLE = 'Check your email';

export function resetSentBody(email) {
  return `If ${email} has an account, a reset link is on its way. It works once and runs out after an hour.`;
}

export const RESET_NOTHING_ARRIVED = 'Nothing arrived? Check your junk folder.';

export const RESET_SEND_ANOTHER = 'Send another link';

// Not in the designs or the ticket: what a failed send says (the request
// never reached the server). Same words as the teacher page's load error.
export const RESET_SEND_FAILED = 'That did not work. Check your connection and try again.';
